import {defineStore} from "pinia";

interface State {
    _ready: boolean;
    _store: { [key: string]: string };
}

export const useStorageStore = defineStore('storage', {
    state: (): State => ({
        _ready: false,
        _store: {}
    }),

    getters: {
        ready: state => {
            return state._ready;
        },
        getValue: (state) => (key: string) => (state._store[key])
    },

    actions: {
        async initialize() {
            if (!this.$state._ready) {
                const {$logger} = useNuxtApp();

                $logger.info('initializing store');

                if (import.meta.client) {
                    const allValues = localStorage.getItem('storage');

                    $logger.info('allValues: ' + allValues);

                    if (!!allValues) {
                        this.$state._store = JSON.parse(allValues);
                    }
                }

                this.$state._ready = true;
            }
        },
        update(key: string, value: string | null) {
            if (import.meta.client) {
                const {$logger} = useNuxtApp();
                $logger.info('updating value');

                const allValues = localStorage.getItem('storage');

                const parsedValues = !!allValues ? JSON.parse(allValues) : {};

                if (!value) {
                    delete parsedValues[key];
                } else {
                    parsedValues[key] = value;
                }

                localStorage.setItem('storage', JSON.stringify(parsedValues));

                this.$state._store = parsedValues;
            }
        }
    }
})
